export function formatTzAbbrev({
  timeZone,
  at,
}: {
  readonly timeZone: string;
  readonly at: Date;
}): string {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "short",
      hour: "numeric",
    }).formatToParts(at);
    const raw = parts.find((p) => p.type === "timeZoneName")?.value ?? "";
    const usZone = /^([A-Z])[SD]T$/.exec(raw);
    return usZone ? `${usZone[1]}T` : raw;
  } catch {
    return timeZone;
  }
}
